import React from "react";
import loadingAnimationData from "../../../assets/animations/lAnimation.json";
import Lottie from "lottie-react";

interface LoadingPlaceholderProps {
	message?: string; // Optional message prop
	animate?: boolean;
}

const LoadingPlaceHolder: React.FC<LoadingPlaceholderProps> = ({
	message,
	animate = true,
}) => {
	return (
		<>
			<div className="bg-white flex flex-col items-center justify-center p-2 px-4 rounded">
				<Lottie
					autoplay
					loop={animate}
					animationData={loadingAnimationData}
					style={{ height: "100px", width: "250px" }}
				/>
				{message && (
					<span className="font-Poppins font-semibold text-lg text-black">
						{message}
					</span>
				)}
			</div>
		</>
	);
};

export default LoadingPlaceHolder;
